import { Directive, ElementRef, OnInit, OnDestroy, AfterViewInit, inject } from '@angular/core';

import { Subscription, fromEvent } from 'rxjs';

import { unsubscribe, KeyCodes, isKeyboardEvent, safeMap } from '@fcom/core/utils';

@Directive({
  selector: '[finPhoneNumberMask]',
  standalone: false,
})
export class PhoneNumberMaskDirective implements OnInit, OnDestroy, AfterViewInit {
  private element = inject(ElementRef);

  private subscription: Subscription;

  ngOnInit(): void {
    this.subscription = new Subscription();
  }

  ngAfterViewInit(): void {
    this.addKeyPressEvent();
    this.addPasteEvent();
  }

  addKeyPressEvent(): void {
    const input = this.element.nativeElement.querySelector('input');
    if (input) {
      this.subscription.add(
        fromEvent(input, 'keypress').subscribe((event: KeyboardEvent) => {
          if (isKeyboardEvent(event, KeyCodes.SPACE)) {
            event.preventDefault();
          }
        })
      );
    }
  }

  addPasteEvent(): void {
    const input = this.element.nativeElement.querySelector('input');
    if (input) {
      this.subscription.add(
        fromEvent(input, 'paste').subscribe((event: ClipboardEvent) => {
          const text =
            safeMap(
              event,
              (e: ClipboardEvent) => e.clipboardData,
              (d: DataTransfer) => d.getData('text/plain')
            ) || '';
          event.preventDefault();
          (event.target as HTMLInputElement).value = text.replace(/ /g, '');
        })
      );
    }
  }

  ngOnDestroy(): void {
    unsubscribe(this.subscription);
  }
}
